import { Routes } from '@angular/router';
1
export const themeRouting: Routes = [
  {
    path: '',
    loadComponent: () =>
      import(
        'src/domains/theme/app/component/full-layout/full-layout.component'
      ).then((c) => c.FullLayoutComponent),
  },
];
